import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import classnames from "classnames";
import Spinner from "./common/Spinner";
//import Spinner from "react-spinkit";

import {
  mqttConnectionInit,
  getPrescriptions,
  draft_view,
  presc_modal_view
} from "../actions/mqttAction";

import { RingLoader } from "react-spinners";

import PrescriptionComponent from "./pharmacist/Prescription/PrescriptionComponent";

import { Dimmer, Image, Segment, Header } from "semantic-ui-react";
import PharmacistDashboard from "./pharmacist/PharmacistDashboard";

import store from "../index";
import { Button, Modal, Icon } from "semantic-ui-react";
import ReviewComponent from "./pharmacist/ReviewComponent";
import PendingView from "./pharmacist/PendingReview/PendingView";
import Approved from "./pharmacist/Approved/Approved";
import ApprovedComponent from "./pharmacist/ApprovedComponent";
import PharmaStoreComponent from "../components/Landing/PharmaStoreComponent";

import { GET_DURINFO, OPEN_STORE_MODAL } from "../actions/types";
class DashboardComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      prescriptionNumber: "",
      patientId: "",
      prescriptio_toView: {}
    };
    this.mainHandler = this.mainHandler.bind(this);

    this.draftModal = this.draftModal.bind(this);
    this.storeModal = this.storeModal.bind(this);
  }

  componentDidMount() { }

  componentWillReceiveProps(nextProps) {
    //console.log("=============Store view==========="+nextProps.mqtt.show_store_view)
    let showPresc,
      showStore,
      prescriptionNumber = "",
      patientId = "",
      prescriptio_toView = {};

    if (nextProps.mqtt.is_modal_view === true) {
      showPresc = nextProps.mqtt.is_modal_view;
      prescriptionNumber = nextProps.mqtt.presc_modal_view.prescriptionNumber;
      patientId = nextProps.mqtt.presc_modal_view.patientId;
      prescriptio_toView = nextProps.mqtt.presc_modal_view.prescription;

      // this.setState({
      //     ...this.state,
      //     open: show,
      //     prescriptionNumber: nextProps.mqtt.presc_modal_view.prescriptionNumber,
      //     patientId: nextProps.mqtt.presc_modal_view.patientId,
      //     prescriptio_toView: nextProps.mqtt.presc_modal_view.prescription
      // })
    } else if (nextProps.mqtt.is_modal_view === false) {
      // let show = nextProps.mqtt.is_modal_view
      // this.setState({
      //     ...this.state,
      //     open: show,
      //     prescriptionNumber: '',
      //     patientId: '',
      //     prescriptio_toView: {}
      // })
    }

    // else if (nextProps.mqtt.show_store_view === true) {
    //     console.log("=============Store view==========="+nextProps.mqtt.show_store_view)

    //     let show = nextProps.mqtt.show_store_view
    //     this.setState({
    //         ...this.state,
    //         show_store: show,
    //     })

    // }
    // else if (nextProps.mqtt.show_store_view === false) {

    //     let show = nextProps.mqtt.show_store_view
    //     this.setState({
    //         ...this.state,
    //         show_store: false,
    //     })

    // }
    showStore = nextProps.mqtt.show_store_view;
    this.setState({
      ...this.state,
      show_store: showStore,
      open: showPresc,
      prescriptionNumber: prescriptionNumber,
      patientId: patientId,
      prescriptio_toView: prescriptio_toView
    });
  }

  mainHandler(user) { }

  // show = (show,size) => () => this.setState({size, open: show})
  close = () => {
    this.props.presc_modal_view(false, {}, "", "");
    this.setState({
      open: false,
      prescriptionNumber: "",
      patientId: "",
      prescriptio_toView: {}
    });
    store.dispatch({ type: GET_DURINFO, payload: {} });
  };

  closeStore = () => {
    // this
    //     .props
    //     .presc_modal_view(false, {}, '', '');
    this.setState({
      show_store: false
    });
    // store.dispatch({type: GET_DURINFO, payload: {}});
    store.dispatch({
      type: OPEN_STORE_MODAL,
      payload: false
    });
    window.location.reload(false);
  };

  draftModal() {
    const { open, size } = this.state;
    let draftModal;
    let prescriptio_toView = this.state.prescriptio_toView;
    if (Object.keys(prescriptio_toView).length > 0) {
      if (
        this.state.prescriptio_toView.rxInfo.rxStatus === "Draft" ||
        this.state.prescriptio_toView.rxInfo.rxStatus === "Rejected"
      ) {
        draftModal = (
          <Modal
            size="fullscreen"
            open={open}
            onClose={this.close}
            className="view-modals px-3 py-3"
            closeIcon
          >
            <PrescriptionComponent
              patientId={this.state.patientId}
              prescription={[this.state.prescriptio_toView]}
              prescriptionNumber={this.state.prescriptionNumber}
              loads={true}
            />
          </Modal>
        );
      }
      if (this.state.prescriptio_toView.rxInfo.rxStatus === "Pending") {
        draftModal = (
          <Modal
            size="fullscreen"
            open={open}
            onClose={this.close}
            className="view-modals px-3 py-3"
            closeIcon
          >
            <PendingView
              patientId={this.state.patientId}
              prescription={[this.state.prescriptio_toView]}
              prescriptionNumber={this.state.prescriptionNumber}
            />
          </Modal>
        );
      }
      if (this.state.prescriptio_toView.rxInfo.rxStatus === "Approved") {
        draftModal = (
          <Modal
            size="fullscreen"
            open={open}
            onClose={this.close}
            className="view-modals px-3 py-3"
            style={{ overflow: "scroll" }}
            closeIcon
          >
            <Approved
              patientId={this.state.patientId}
              prescription={[this.state.prescriptio_toView]}
              prescriptionNumber={this.state.prescriptionNumber}
            />
          </Modal>
        );
      }
      if (this.state.prescriptio_toView.rxInfo.rxStatus === "Dispensed") {
        draftModal = (
          <Modal
            size="fullscreen"
            open={open}
            onClose={this.close}
            className="view-modals px-3 py-3"
            style={{ overflow: "scroll" }}
            closeIcon
          >
            <Approved
              patientId={this.state.patientId}
              prescription={[this.state.prescriptio_toView]}
              prescriptionNumber={this.state.prescriptionNumber}
            />
          </Modal>
        );
      }
    }

    return draftModal;
  }

  storeModal() {
    let storeModal
    if (this.state.show_store) {
      const { show_store, rxNumber, branchName, destinationName, size } = this.state.show_store;
      storeModal = (
        <Modal
          size="fullscreen"
          open={show_store}
          onClose={this.closeStore}
          className="view-modals px-3 py-3"
          style={{ overflow: "scroll" }}
          closeIcon
        >
          <PharmaStoreComponent
            prescriptionNumber={rxNumber}
            branchInfo={branchName}
            roomInfo={destinationName} />
        </Modal>
      );
    }

    return storeModal;
  }

  render() {
    return (
      <div>
        {this.draftModal()}
        {this.storeModal()}
        <PharmacistDashboard handler={this.mainHandler} />
      </div>
    );
  }
}

DashboardComponent.propTypes = {
  mqttConnectionInit: PropTypes.func.isRequired,
  getPrescriptions: PropTypes.func.isRequired,
  mqtt: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
  draft_view: PropTypes.func.isRequired,
  presc_modal_view: PropTypes.func.isRequired
};

const mapStateToProps = state => ({ mqtt: state.mqtt, auth: state.auth });

export default connect(mapStateToProps, {
  mqttConnectionInit,
  getPrescriptions,
  draft_view,
  presc_modal_view
})(DashboardComponent);
